import React from "react";
import { useFela } from "react-fela";

import { Heading } from "@/components/Heading";
import { useTheme } from "@/hooks/useTheme";
import { Badge } from "@/components/Badge";
import { IListElement } from "../types";
import { Icon } from "../../../components/Icon";

export const ListElementWithTitle: React.FC<IListElement> = ({
  iconType,
  title,
  text,
  ...rest
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  return (
    <li
      className={css({
        marginTop: 20,
        display: "flex",
        [bp.FROM_DESKTOP]: {
          marginTop: 30,
        },
      })}
      {...rest}
    >
      <Badge
        size={40}
        customStyle={{
          backgroundColor: colors.WHITE,
          boxShadow: `4px 8px 8px 0 ${colors.CETACEAN_BLUE}`,
          flexShrink: 0,
        }}
      >
        <Icon iconType={iconType} />
      </Badge>

      <div
        className={css({
          marginLeft: 16,
        })}
      >
        <Heading
          as="h4"
          customStyle={{
            letterSpacing: "0.5px",
            color: colors.DARK_GREY,
            marginBottom: 8,
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            fontSize: 14,
            lineHeight: "22px",
            color: colors.GRAY,
          })}
        >
          {text}
        </p>
      </div>
    </li>
  );
};
